import { render, staticRenderFns } from "./CopyTextDialog.vue?vue&type=template&id=ce41f242&"
import script from "./CopyTextDialog.vue?vue&type=script&lang=ts&"
export * from "./CopyTextDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CopyTextDialog.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports